import { useCallback, useState } from "react";
import { CreateAuditDialog } from "@/components/audits/CreateAuditDialog";
import { RequestGuidanceDialog } from "@/components/audits/RequestGuidanceDialog";
import { ProjectsList } from "@/components/projects/ProjectsList";
import { PageHeader } from "@/components/shared/page-header";
import { useSession } from "@/lib/auth-client";

export function ProjectsPage() {
  const { data: session } = useSession();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedProjectId, setSelectedProjectId] = useState<string | undefined>();
  const [guidanceDialogOpen, setGuidanceDialogOpen] = useState(false);
  const [guidanceProjectId, setGuidanceProjectId] = useState<string | undefined>();

  const role = session?.user?.role ?? "";
  const canCreateAudit = role === "admin" || role === "compliance_manager";

  const handleCreateAudit = useCallback((projectId: string) => {
    setSelectedProjectId(projectId);
    setDialogOpen(true);
  }, []);

  const handleRequestGuidance = useCallback((projectId: string) => {
    setGuidanceProjectId(projectId);
    setGuidanceDialogOpen(true);
  }, []);

  return (
    <>
      <div className="space-y-6">
        <PageHeader
          title="Projects"
          description="Browse all projects and drill down to see their associated audits."
        />
        <ProjectsList
          canCreateAudit={canCreateAudit}
          onCreateAudit={handleCreateAudit}
          onRequestGuidance={handleRequestGuidance}
        />
      </div>

      <CreateAuditDialog
        open={dialogOpen}
        onOpenChange={setDialogOpen}
        defaultProjectId={selectedProjectId}
      />

      <RequestGuidanceDialog
        open={guidanceDialogOpen}
        onOpenChange={setGuidanceDialogOpen}
        projectId={guidanceProjectId}
      />
    </>
  );
}
